import FirstBannerType from './FirstBannerType';

export default FirstBannerType;
